import React from 'react'

import T from 'components/FormattedMessage'

import { injectIntl, WrappedComponentProps } from 'react-intl'

import ordinalize from 'lib/ordinalize'

interface Props {
  value: number
}

type InjectedProps = Props & WrappedComponentProps

const Rank = ({ value, intl }: InjectedProps) => (
  <T id="common_rank_format" values={{ rank: ordinalize(value, intl.locale) }} />
)

export default injectIntl(Rank)
try {
    // @ts-ignore
    Rank.displayName = "Rank";
    // @ts-ignore
    Rank.__docgenInfo = { "description": "", "displayName": "Rank", "props": { "value": { "defaultValue": null, "description": "", "name": "value", "required": true, "type": { "name": "number" } }, "forwardedRef": { "defaultValue": null, "description": "", "name": "forwardedRef", "required": false, "type": { "name": "Ref<any>" } }, "ref": { "defaultValue": null, "description": "", "name": "ref", "required": false, "type": { "name": "Ref<any>" } }, "key": { "defaultValue": null, "description": "", "name": "key", "required": false, "type": { "name": "string | number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/Rank/Rank.tsx#Rank"] = { docgenInfo: Rank.__docgenInfo, name: "Rank", path: "src/components/Rank/Rank.tsx#Rank" };
}
catch (__react_docgen_typescript_loader_error) { }